<template>
  <div class="company-list">

    <div class="company-item" v-for="(item, index) in listData" :key="index" @click="toCompanyDetail(item.token)">
      <img class="company-logo" :src="item.company_logo" alt="">
      <div class="company-info">
        <p class="company-title">{{ item.company_name }}</p>
        <p class="company-desc">
          <span v-if="item.city">{{ item.city }}</span>
          <span v-if="item.industry">{{ item.industry }}</span>
          <span v-if="item.scale">{{ item.scale }}</span>
        </p>
      </div>
    </div>

  </div>
</template>

<script>
import { envMixin } from '../../assets/js/mixin/global'

export default {
  props: {
    listData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
    }
  },
  mixins: [ envMixin ],
  mounted () {},
  computed: {
    miniType () {
      return this.$route.query.in
    }
  },
  components: {},
  methods: {
    toCompanyDetail(token){
      window.location.href = `${process.env.VUE_APP_HOST}/company/${token}.html`
    }
  }
}
</script>

<style lang="scss" scoped>
.company-list {
  width: 100%;

  .company-item {
    display: flex;
    align-items: center;
    padding: 14px;
    background: #ffffff;
    border-radius: 6px;
    margin: 10px 16px 0;

    .company-logo {
      width: 46px;
      height: 46px;
      border-radius: 6px;
      border: 1px solid #F4F4F4;
      object-fit: cover;
      object-position: center;
      margin-right: 10px;
    }

    .company-info {
      flex: 1;
    }

    .company-title {
      width: 240px;
      height: 16px;
      font-size: 16px;
      font-weight: 500;
      color: #404040;
      line-height: 16px;
      margin-bottom: 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .company-desc {
      width: 240px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      >span {
        position: relative;
        font-size: 14px;
        font-weight: 400;
        color: #9C9C9C;
        line-height: 14px;
        margin-right: 13px;

        &::after {
          content: "";
          position: absolute;
          top: 50%;
          right: -7px;
          transform: translateY(-50%);
          width: 1px;
          height: 10px;
          background: #ECECEC;
          z-index: 10;
        }

        &:last-of-type {
          margin-right: 0;

          &::after {
            display: none;
          }
        }

      }
    }
  }
}
</style>
